import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import Snackbar from "./components/common/SnackBar/snackBar";
import "./assets/fonts/font.css";
import { CartProvider } from "./context/CartContext";
import { applyBrandTheme, getCurrentBrand } from "./configs/brandConfigs";

const activeBrand = getCurrentBrand();
if (activeBrand) {
  applyBrandTheme(activeBrand);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CartProvider>
        <CssBaseline />
        <Snackbar>
          <App />
        </Snackbar>
      </CartProvider>
    </Provider>
  </React.StrictMode>
);
